import moment from 'moment/moment'

export const getFormattedDate = (dateString: string) => {
  return moment(dateString, 'YYYY-MM-DD').format('DD MMM')
}
